import { toJS } from 'mobx'

export const isObj = obj =>
  Object.prototype.toString.call(obj) === '[object Object]'

export const isArray = obj => Array.isArray(toJS(obj))

export const isString = obj =>
  Object.prototype.toString.call(obj) === '[object String]'
